<!--模板-->
<template>
  <div>
    <div class="info">
      <p class="align">《隐私政策》</p>
      <div class="textInfo">更新日期：2026年04月22日</div>
      <div class="textInfo">生效日期：2021年12月19日</div>
      <div class="textInfo">引言</div>
      <div class="textInfo">
        成都爱找我科技有限公司（以下简称“找我请柬”）非常重视您（也称“用户”）的个人信息，并让您对个人信息拥有控制权，找我请柬会使用强大的加密技术来保护您的隐私，同时制定严格的政策来管理所有数据。当您访问找我请柬运营的找我请柬平台时，或使用找我请柬提供的服务前，您需要同意本政策中关于找我请柬如何收集、使用、储存和分享您的相关信息的规定。如果您不同意本隐私政策中的任何内容，请立即停止使用或访问找我请柬的产品和服务。<b
          >本政策中与您权益（可能）存在重大关系的条款，我们已使用加粗字体予以区别，请您重点查阅。</b
        >
      </div>
      <div class="textInfo">
        本隐私权政策旨在协助您了解找我请柬会收集哪些信息、为什么收集这些信息，以及您如何更新、管理、导出和删除自己的信息。若您对本政策有任何问题，请联系：service@izhaowo.com
      </div>
      <div class="textInfo">术语</div>
      <div class="textInfo">
        Cookie：Cookie
        是包含字符串的小文件，会在您访问网站时发送到您的计算机上。当您再次访问网站时，Cookie
        使该网站可以识别您的浏览器。Cookie
        还能存储用户使用偏好及其他信息。您可以重置您的浏览器拒绝所有的
        Cookie，或者在发送 Cookie 时提示。但如果没有
        Cookie，某些网站功能或服务可能无法正常工作。
      </div>
      <div class="textInfo">
        应用数据缓存：应用数据缓存是指设备上的一种数据存储机制。使用它有很多好处，例如，可让网络应用在未连接互联网的情况下运行，以及可通过提高内容加载速度来改善相关应用的性能。
      </div>
      <div class="textInfo">
        个人信息：用户向找我请柬提供的、可用于识别用户的个人身份的信息，例如姓名、电子邮件地址、电话号码、银行卡号、身份证号码、住址、通讯记录等信息，或找我请柬可以正当地通过链接找到此类信息的其他数据。
      </div>
      <div class="textInfo">
        IP地址：每台连接到互联网的计算机都指定了唯一的编号，称为互联网协议 (IP)
        地址。由于这些编号通常都是根据国家/地区的区域指定的，因此 IP
        地址通常可用于识别计算机连接至互联网时所在的国家/地区。
      </div>
      <p>一. 找我请柬如何搜集和使用您的信息？</p>
      <div class="textInfo">1. 找我请柬如何搜集您的信息？</div>
      <div class="textInfo">
        找我请柬提供服务时，可能会收集、储存和使用下列信息：
      </div>
      <div class="textInfo">1.1 您提供的信息</div>
      <div class="textInfo">
        1.1.1
        您在注册账户或使用找我请柬的服务时，向找我请柬提供的相关个人信息，例如您的<b>姓名、电子邮件地址、电话号码、住址、身份证号码等信息。</b>如果您想充分使用找我请柬提供的各种分享功能，可能还需要<b
          >创建公开显示的个人资料，其中可能会包含您的姓名和照片。</b
        >
      </div>
      <div class="textInfo">
        1.1.2
        您通过找我请柬的服务向其他方提供的共享信息，以及您使用找我请柬的服务时上传、提交、存储、发送或接收的信息。
      </div>
      <div class="textInfo">1.2 您在使用服务过程中，找我请柬获取的信息</div>
      <div class="textInfo">
        <b>找我请柬会收集您使用的服务以及使用方式的信息，</b
        >如您何时在找我请柬浏览产品，何时访问了找我请柬的产品服务，或何时查看了找我请柬的广告和内容。此类信息包括：
      </div>
      <div class="textInfo"><b>1.2.1 日志信息</b></div>
      <div class="textInfo">
        A.
        设备或软件信息，例如您的移动设备、网页浏览器或用于接入找我请柬服务的其他程序所提供的配置信息、您的IP地址和移动设备所用的版本和设备识别码；
      </div>
      <div class="textInfo">
        B.
        在使用找我请柬服务时搜索或浏览的信息，例如您使用的网页搜索词语、访问的社交媒体页面url地址，以及您在使用找我请柬服务时浏览或要求提供的其他信息和内容详情；
      </div>
      <div class="textInfo"><b>1.2.2 IP地址</b></div>
      <div class="textInfo">
        A.
        有关您<b>曾使用的移动应用（APP）和其他软件的信息，</b>以及您曾经使用该等移动应用和软件的信息；
      </div>
      <div class="textInfo">
        B.
        您通过找我请柬的服务进行通讯的信息，例如曾通讯的账号，以及通讯时间、数据和时长；
      </div>
      <div class="textInfo">
        C. 您通过找我请柬的服务分享的内容所包含的信息（元数据），例如<b
          >拍摄或上传的共享照片或录像的日期、时间或地点等。</b
        >
      </div>
      <div class="textInfo">1.2.3 设备中的视频、图片等</div>
      <div class="textInfo">
        为了给您提供全方位的购物体验，经过您的授权，找我请柬的服务器会提取您设备中的<b>视频、图片、版本号等，</b>并通过加密上传到服务器进行比对，用于匹配与该视频、图片、相对应的显示功能。
      </div>
      <div class="textInfo"><b>1.2.4 摄像头</b></div>
      <div class="textInfo">
        除本协议另有约定外，您设备上的摄像功能是保证您能多角度观看产品效果必备工具，如您禁用摄像功能，可能无法使用找我请柬的部分产品或服务，或在使用过程中达不到最佳效果或使用受到限制。找我请柬不会利用摄像头采集您的个人照片，除非经您授权或您自行上传、提交、发布，找我请柬不会主动采集您设备中的图片、视频信息。
      </div>
      <div class="textInfo"><b>1.2.5 位置信息</b></div>
      <div class="textInfo">
        为了让您更快的找到周边门店和相关服务，您可以授权开启设备定位功能并使用找我请柬基于位置提供的相关服务，当然，您也可以通过关闭定位功能随时停止找我请柬对您的地理位置信息的收集。
      </div>
      <div class="textInfo"><b>1.2.6 通讯录和好友圈</b></div>
      <div class="textInfo">
        如您想分享找我请柬产品内容及图片给通讯录，找我请柬将根据您的授权上传并保存您的应用列表，并以加密方式上传并保存用户通讯录中联系人手机号码，通过与服务器中信息匹配为您提供特色服务。
      </div>
      <div class="textInfo">1.2.7 安全运行与风控验证</div>
      <div class="textInfo">
        为了保障软件与服务的安全运行，防止您的个人信息被非法获取，更准确地预防欺诈和保护账号安全，我们会收集您的<b
          >设备信息【包括:设备型号、设备名称、SIM卡序列号、设备唯一标识符(包括:<span
            style="font-weight: 600"
            >IMEI、IMSI、AndroidiD、IDFA</span
          >)】、地理位置、存储(相册、媒体和其他文件)、浏览器类型和设置、语言设置、操作系统和应用程序版本、网络设备硬件地址(MAC地址)、登录IP地址、接入网络的方式、网络质量数据、移动网络信息(包括运营商名称)、产品版本号以及软件使用记录信息，</b
        >如您不同意我们收集前述信息，可能无法完成风控验证。请您理解，为动态检测您的账户是否存在异常登录，每次您把找我请柬App切换至后台或重新启动程序时，我们可能会再次读取，我们将把读取频次控制在合理范围内。
      </div>
      <div class="textInfo">1.3第三方应用工具包</div>
      <div class="textInfo">
        为了能够更高效地完成产品研发，为用户提供更为多元化的服务，找我请柬在找我请柬
        App 中采用了第三方提供的软件开发工具包 。这种工具包通常称为
        SDK（Software Development
        Kit），是指用于为特定的软件包、软件框架、硬件平台、操作系统等创建应用软件的开发工具的集合。找我请柬使用的
        SDK 包括以下类型：
      </div>
      <!-- <div class="textInfo">A. 用于支持快捷注册或登录的 SDK（中国移动/联通/电信一键登录）</div>
<div class="textInfo">B. 用于优化浏览和信息发布功能的 SDK（高德定位、Weibo SDK、极光推送）</div>
<div class="textInfo">C. 用于提供支付功能的 SDK（alipay、微信支付）</div>
<div class="textInfo">D. 用于进行数据监测的 SDK（百度统计、友盟）</div>
<div class="textInfo">E. 用于故障收集分析、帐号安全性核验的 SDK（百度统计、友盟、腾讯Bugly）</div>
<div class="textInfo">F. 设备制造商和操作系统厂商的 SDK</div> -->
      <div>
        <table
          style="
            border-collapse: collapse;
            border: 1px solid #ececec;
            width: 100%;
          "
        >
          <tr>
            <td width="10%">第三方公司名称</td>
            <td width="10%">产品/类型</td>
            <td width="20%">共享信息名称</td>
            <td width="10%">使用目的</td>
            <td width="10%">使用场景</td>
            <td width="10%">共享方式</td>
            <td width="30%">共享方式 第三方个人信息处理规则</td>
          </tr>
          <tr>
            <td colspan="7">一键登录</td>
          </tr>
          <tr>
            <td>中移互联网有限公司</td>
            <td>移动登录</td>
            <td><b>设备信息、网络设备硬件地址、网络信息、OAID</b></td>
            <td>一键登录</td>
            <td>一键登录</td>
            <td>SDK本机采集</td>
            <td>
              <a
                href="http://dev.10086.cn/docInside?contentId=10000009826805"
                target="_blank"
                >http://dev.10086.cn/docInside?contentId=10000009826805</a
              >
            </td>
          </tr>
          <tr>
            <td>中国电信股份有限公司</td>
            <td>电信</td>
            <td><b>网络信息、读取手机状态</b></td>
            <td>一键登录</td>
            <td>一键登录</td>
            <td>SDK本机采集</td>
            <td>
              <a href="https://e.189.cn/legalStatement.jsp" target="_blank"
                >https://e.189.cn/legalStatement.jsp</a
              >
            </td>
          </tr>
          <tr>
            <td>中国联通网络信息集团有限公司</td>
            <td>联通</td>
            <td><b>网络信息、读取手机状态</b></td>
            <td>一键登录</td>
            <td>一键登录</td>
            <td>SDK本机采集</td>
            <td>
              <a
                href="http://m.client.10010.com/mobileService/tuwenhunpai/notice_1527478459203.html"
                target="_blank"
                >http://m.client.10010.com/mobileService/tuwenhunpai/notice_1527478459203.html</a
              >
            </td>
          </tr>
          <tr>
            <td colspan="7">地图及定位</td>
          </tr>
          <tr>
            <td>高德软件有限公司</td>
            <td>高德地图</td>
            <td>
              <b
                >网络信息、地理位置、读取存储（信息、媒体和其他文件）权限、设备传感器信息</b
              >
            </td>
            <td>用于展现地图</td>
            <td>门店定位</td>
            <td>SDK本机采集</td>
            <td>
              <a href="https://lbs.amap.com/pages/privacy/" target="_blank"
                >https://lbs.amap.com/pages/privacy/</a
              >
            </td>
          </tr>
          <tr>
            <td>高德软件有限公司</td>
            <td>高德定位</td>
            <td>
              <b
                >地图位置（包含在后台状态下收集）、谁被信息、网络设备硬件地址、网络信息、读取存储（信息、媒体和其他文件）权限</b
              >
            </td>
            <td>帮助用户寻找附近门店时提供帮助</td>
            <td>门店定位</td>
            <td>SDK本机采集</td>
            <td>
              <a href="https://lbs.amap.com/pages/privacy/" target="_blank"
                >https://lbs.amap.com/pages/privacy/</a
              >
            </td>
          </tr>
          <tr>
            <td colspan="7">其他</td>
          </tr>
          <tr>
            <td>支付宝（中国）网络技术有限公司</td>
            <td>支付宝</td>
            <td>
              <b
                >设备信息、网络设备地址、网络信息、读取存储（信息、媒体和其他文件）权限、读取手机状态</b
              >
            </td>
            <td>支持支付宝支付</td>
            <td>支付场景</td>
            <td>SDK本机采集</td>
            <td>
              <a href="https://opendocs.alipay.com/open/54" target="_blank"
                >https://opendocs.alipay.com/open/54</a
              >
            </td>
          </tr>
          <tr>
            <td>深圳市腾讯计算机系统有限公司</td>
            <td>微信开放平台</td>
            <td><b>/</b></td>
            <td>支持微信授权登陆场景和支付场景</td>
            <td>使用微信登录、微信分享和支付场景</td>
            <td>SDK本机采集</td>
            <td>
              <a
                href="https://open.weixin.qq.com/cgi-bin/frame?t=news/protocol_developer_tmpl"
                target="_blank"
                >https://open.weixin.qq.com/cgi-bin/frame?t=news/protocol_developer_tmpl</a
              >
            </td>
          </tr>
          <tr>
            <td>深圳市腾讯计算机系统有限公司</td>
            <td>QQ开放平台</td>
            <td>
              <b
                >设备信息、网络设备地址、网络信息、读取存储（信息、媒体和其他文件）权限</b
              >
            </td>
            <td>帮助用户分享内容到QQ</td>
            <td>帮助用户分享内容到QQ</td>
            <td>SDK本机采集</td>
            <td>
              <a
                href="https://wiki.connect.qq.com/qq%e4%ba%92%e8%81%94sdk%e9%9a%90%e7%a7%81%e4%bf%9d%e6%8a%a4%e5%a3%b0%e6%98%8e"
                target="_blank"
                >https://wiki.connect.qq.com/qq%e4%ba%92%e8%81%94sdk%e9%9a%90%e7%a7%81%e4%bf%9d%e6%8a%a4%e5%a3%b0%e6%98%8e</a
              >
            </td>
          </tr>
          <tr>
            <td>北京微梦创科网络技术有限公司</td>
            <td>微博</td>
            <td>
              <b
                >设备信息、网络设备地址、网络信息、读取存储（信息、媒体和其他文件）权限</b
              >
            </td>
            <td>帮助用户分享内容至微博</td>
            <td>分享至微博</td>
            <td>SDK本机采集</td>
            <td>
              <a
                href="https://open.weibo.com/wiki/Android_SDK%E8%AF%B4%E6%98%8E%E6%96%87%E6%A1%A3"
                target="_blank"
                >https://open.weibo.com/wiki/Android_SDK%E8%AF%B4%E6%98%8E%E6%96%87%E6%A1%A3</a
              >
            </td>
          </tr>
          <tr>
            <td>阿里巴巴集团控股有限公司</td>
            <td>阿里云</td>
            <td><b>网络信息、读取存储（信息、媒体和其他文件）权限</b></td>
            <td>用于笔记发布、请柬制作、图片存储</td>
            <td>用户制作请柬、发布笔记的场景</td>
            <td>SDK本机采集</td>
            <td>
              <a
                href="https://help.aliyun.com/document_detail/372512.html?spm=5176.22414175.sslink.1.6ab16422P6Ls9a"
                target="_blank"
                >https://help.aliyun.com/document_detail/372512.html?spm=5176.22414175.sslink.1.6ab16422P6Ls9a</a
              >
            </td>
          </tr>
          <tr>
            <td>阿里巴巴集团控股有限公司</td>
            <td>阿里云OSS</td>
            <td><b>网络信息、读取存储（信息、媒体和其他文件）权限</b></td>
            <td>用于笔记发布、请柬制作、图片存储</td>
            <td>用户制作请柬、发布笔记的场景</td>
            <td>SDK本机采集</td>
            <td>
              <a
                href="https://help.aliyun.com/document_detail/372512.html?spm=5176.22414175.sslink.1.6ab16422P6Ls9a"
                target="_blank"
                >https://help.aliyun.com/document_detail/372512.html?spm=5176.22414175.sslink.1.6ab16422P6Ls9a</a
              >
            </td>
          </tr>
          <tr>
            <td>百度在线网络技术（北京）有限公司</td>
            <td>百度统计</td>
            <td>
              <b
                >【安卓】设备信息（设备型号、系统版本、oaid、IMEI、AndroidID、等）、日志信息、应用程序列表信息、设备信息、读取/写入外部存储卡、获取运行列表、查看WLAN连接、读取手机状态和身份、使用蓝牙
                【IOS】设备信息（设备型号、系统版本、系统总内存占用空间、操作系统等基础信息）、日志信息、应用程序列表信息、剪切板中的口令、链接等内容、读取/写入外部存储卡、获取运行列表、查看WLAN连接、使用蓝牙、广告标识符IDFA
              </b>
            </td>
            <td>
              用于进行各功能的使用量、版本覆盖率等有助开发者、运营人员改善服务的数据监测，并且已做脱敏处理
            </td>
            <td>
              （1）应用第一次安装启动时，收集系统基础信息和软件版本号
              （2）新页面加载时，收集页面路径的加载次数等
              （3）退出页面时，收集页面停留时长和页面路径退出次数。
              （4）当有埋点时，收藏其他按钮的点击次数信息
            </td>
            <td>SDK本机采集</td>
            <td>
              <a
                href="https://tongji.baidu.com/web/help/article?id=330&type=0"
                target="_blank"
                >https://help.aliyun.com/document_detail/372512.html?spm=5176.22414175.sslink.1.6ab16422P6Ls9a</a
              >
            </td>
          </tr>
          <tr>
            <td>北京巨量引擎网络技术有限公司</td>
            <td>巨量引擎</td>
            <td><b>设备信息、网络设备地址、网络信息</b></td>
            <td>用于收集广告推广效果</td>
            <td>应用第一次安装启动时</td>
            <td>SDK本机采集</td>
            <td>
              <a
                href="https://open.oceanengine.com/labels/7/docs/1730079845340164"
                target="_blank"
                >https://help.aliyun.com/document_detail/372512.html?spm=5176.22414175.sslink.1.6ab16422P6Ls9a</a
              >
            </td>
          </tr>
          <tr>
            <td>深圳市和讯华谷信息技术有限公司</td>
            <td>极光</td>
            <td>
              <b>设备信息、地理位置、网络信息、WIFI的SSID、获取安装列表</b>
            </td>
            <td>一键登录</td>
            <td>应用第一次安装启动时</td>
            <td>SDK本机采集</td>
            <td>
              <a href="https://www.jiguang.cn/license/privacy" target="_blank"
                >https://www.jiguang.cn/license/privacy</a
              >
            </td>
          </tr>
          <tr>
            <td>武汉极意网络科技有限公司</td>
            <td>极验</td>
            <td>
              <b
                >手机号、运营商类型、SDK版本信息、应用名称、设备制造商、设备型号、设备宽高</b
              >
            </td>
            <td>短信防刷</td>
            <td>短信获取超过3次时</td>
            <td>SDK本机采集</td>
            <td>
              <a href="https://www.geetest.com/Private" target="_blank"
                >https://www.geetest.com/Private</a
              >
            </td>
          </tr>
          <tr>
            <td>深圳市腾讯计算机系统有限公司</td>
            <td>腾讯移动分析平台mta</td>
            <td>
              <b
                >设备信息、网络信息、获取运行列表、查看WLAN连接、读取手机状态和身份</b
              >
            </td>
            <td>用于收集应用的页面加载和点击事件</td>
            <td>App启动时</td>
            <td>SDK本机采集</td>
            <td>
              <a
                href="https://privacy.qq.com/policy/tencent-privacypolicy"
                target="_blank"
                >https://privacy.qq.com/policy/tencent-privacypolicy</a
              >
            </td>
          </tr>

          <tr>
            <td>小米推送SDK</td>
            <td>北京小米移动软件有限公司</td>
            <td>
              <b
                >设备标识(OAID、加密的Android
                ID)、推送消息内容、设备信息(设备厂商、型号、归属地、运营商名称等)、通知栏设置</b
              >
            </td>
            <td>用于推送消息</td>
            <td>App启动时</td>
            <td>SDK本机采集</td>
            <td>
              <a
                href="https://dev.mi.com/distribute/doc/details?pId=1534"
                target="_blank"
                >https://dev.mi.com/distribute/doc/details?pId=1534</a
              >
            </td>
          </tr>
          <tr>
            <td>vivo推送SDK</td>
            <td>维沃移动通信有限公司</td>
            <td>
              <b
                >应用基本信息、应用内设备标识符、设备的硬件信息、系统基本信息</b
              >
            </td>
            <td>提供推送消息服务、统计推送SDK接口调用成功率。</td>
            <td>App启动时</td>
            <td>SDK本机采集</td>
            <td>
              <a
                href="https://dev.vivo.com.cn/documentCenter/doc/652"
                target="_blank"
                >https://dev.vivo.com.cn/documentCenter/doc/652</a
              >
            </td>
          </tr>
          <tr>
            <td>OPUSH SDK</td>
            <td>广东欢太科技有限公司</td>
            <td><b>设备信息、应用信息、网络信息</b></td>
            <td>推送通知栏消息</td>
            <td>App启动时</td>
            <td>SDK本机采集</td>
            <td>
              <a
                href="https://open.oppomobile.com/new/developmentDoc/info?id=10288"
                target="_blank"
                >https://open.oppomobile.com/new/developmentDoc/info?id=10288</a
              >
            </td>
          </tr>
          <tr>
            <td>华为推送SDK</td>
            <td>华为软件技术有限公司</td>
            <td>
              <b
                >应用基本信息、应用内设备标识符、设备的硬件信息、系统基本信息和系统设置信息</b
              >
            </td>
            <td>提供消息推送服务 统计华为推送SDK接口调用成功率</td>
            <td>App启动时</td>
            <td>SDK本机采集</td>
            <td>
              <a
                href="https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177"
                target="_blank"
                >https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177</a
              >
            </td>
          </tr>
          <tr>
            <td>Flyme推送SDK</td>
            <td>珠海星纪魅族信息技术有限公司</td>
            <td>
              <b>手机品牌、手机型号、系统版本、系统语言，以及设备标识符</b>
            </td>
            <td>推送通知栏消息</td>
            <td>App启动时</td>
            <td>SDK本机采集</td>
            <td>
              <a href="http://open.flyme.cn/docs?id=202" target="_blank"
                >http://open.flyme.cn/docs?id=202</a
              >
            </td>
          </tr>
        </table>
      </div>
      <div class="textInfo">除此外，还包括其他功能相关的：</div>
      <div class="textInfo">
        A. 用于<b>进行数据监测，并且已做脱敏处理的的 SDK</b>（百度统计、友盟）
      </div>
      <div class="textInfo">
        B 用于<b>故障收集分析、帐号安全性核验</b>的
        SDK（百度统计、友盟、腾讯Bugly）
      </div>
      <div class="textInfo">C <b>支付方式 </b></div>
      <div class="textInfo">
        名称：微信支付 运营方名称：深圳市腾讯计算机系统有限公司<br />
        使用目的：帮助用户完成微信支付<br />
        收集信息类型：设备信息(IMSI、IMEI、MAC地址、AndroidID)<br />
        收集方式：SDK本机采集、不涉及数据共享<br />
        官方说明或隐私政策：https://pay.weixin.qq.com/static/applyment_guide/applyment_index.shtml
      </div>
      <div class="textInfo">D <b>微信登录及微信分享 </b></div>
      <div class="textInfo">
        名称：微信 运营方名称：深圳市腾讯计算机系统有限公司<br />
        使用目的：微信登录、分享、帮助用户完成付款、提供安全认证服务<br />
        收集信息类型：设备信息(IMSI、IMEI、MAC地址、UUID、AndroidID)、设备存储<br />
        收集方式：SDK本机采集、不涉及数据共享 官方说明或隐私政策：<br />
        https://developers.WeChat.qq.com/doc/oplatform/Mobile_App/Access_Guide/Android.html
      </div>
      <div class="textInfo">2. 找我请柬可能将上述收集的信息用作以下用途：</div>
      <div class="textInfo">2.1 向您提供服务；</div>
      <div class="textInfo">
        2.2
        <b
          >在找我请柬提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保找我请柬向您提供的产品和服务的安全性；</b
        >
      </div>
      <div class="textInfo">
        2.3 帮助找我请柬设计新服务，改善找我请柬现有服务；
      </div>
      <div class="textInfo">2.4 执行软件验证、升级服务；</div>
      <div class="textInfo">
        2.5
        应用户特殊要求而提供特定服务时，需要将信息提供给找我请柬的关联公司、第三方或其他用户；
      </div>
      <div class="textInfo">
        2.6 其他有利于用户和找我请柬运营者利益且不违反任何强制性法律法规的情况。
      </div>
      <div class="textInfo">2.7 让您参与有关找我请柬产品和服务的调查</div>
      <div class="textInfo">3. 找我请柬承诺</div>
      <div class="textInfo">
        3.1
        我们不会根据敏感类别（例如种族、宗教、性取向或健康状况）向您展示个性化广告；
      </div>
      <div class="textInfo">
        3.2
        <b
          >我们不会与广告主分享可用于识别您个人身份的信息，例如您的姓名或电子邮件地址（除非经您授权同意）；</b
        >
      </div>
      <div class="textInfo">
        3.3
        <b
          >在任何时候、任何情况下都不会向任何第三方出售您的个人信息，我们只会在法律允许的范围内使用根据本协议获得的信息。我们会制定严格的政策保护您的个人信息，除非事先获得您的授权或本声明另有规定之外，不会将您的这些信息对外公开或向第三方提供。</b
        >
      </div>
      <div class="textInfo">
        4. 找我请柬不会将您的个人信息转移或披露给任何非关联的第三方，除非：
      </div>
      <div class="textInfo">
        5.1 相关法律法规、法律程序、政府机关的强制性要求；
      </div>
      <div class="textInfo">5.2 为完成合并、分立、收购或资产转让而转移；</div>
      <div class="textInfo">3.3 事先获得您的授权；</div>
      <div class="textInfo">5.4 您使用共享功能；</div>
      <div class="textInfo">5.5 以学术研究或公共利益为目的；</div>
      <div class="textInfo">
        5.6 找我请柬认为必要且不违反法律强制性规定的其他情形。
      </div>
      <div class="textInfo">
        6.
        <b>除非经过您的同意，否则找我请柬不会向任何人提供您的敏感个人信息。</b>
      </div>
      <p><b>二. 如何更新、变更、导出、删除您的信息</b></p>
      <div class="textInfo">
        1.
        您在使用找我请柬的产品和服务时，会被要求提供您真实的个人信息，您应当对您所提供信息的真实性、合法性、有效性及完整性负责，并及时更新和维护您的个人信息，以保证信息的真实、合法和有效。您可以随时管理您的个人信息，例如您的个人账户注册信息。
      </div>
      <div class="textInfo">
        2.
        <b
          >您可以自行从找我请柬账号中删除您的内容或个人信息，或要求找我请柬删除或修改信息，</b
        >例如您想要删除个人帐户，可以发送邮件到service@izhaowo.com与我们联络并提出您的要求。
      </div>
      <div class="textInfo">
        3.
        在有些情况下，找我请柬会出于法律目的或合法业务的需要将数据保留有限的一段时间。找我请柬会尽力确保找我请柬的服务能够保护信息免遭意外或恶意删除。因此，如果您删除了某些内容，找我请柬可能会过一段时间才会从找我请柬现用的和备用的系统中删除其副本。
      </div>
      <div class="textInfo">
        4.
        <b
          >您可以随时备份个人帐户名下的内容或将其用于非找我请柬服务，您可以发邮件到service@izhaowo.com与找我请柬联络并提出您的要求。</b
        >
      </div>
      <p>三. 找我请柬如何保护您的个人信息</p>
      <div class="textInfo">
        1.
        所有找我请柬产品都内置了强大的安全功能，并且找我请柬制定了严格的信息管理政策，配备专业的技术团队，采取了一系列合理的预防措施，以保护您的个人信息不会遭受未经授权的浏览、披露、滥用、变更、破坏以及损失，其中包括：
      </div>
      <div class="textInfo">
        （1）使用加密技术来确保您的数据在传输过程中保持私密性；
      </div>
      <div class="textInfo">
        （2）提供多种安全功能来协助您保护自己的帐号安全；
      </div>
      <div class="textInfo">
        （3）审查找我请柬在收集、存储和处理信息方面的做法（包括实体安全措施），以防未经授权的人员访问找我请柬的系统；
      </div>
      <div class="textInfo">
        （4）所有因提供服务而必须接触个人信息的找我请柬员工、承包商和代理商等，都需要遵守合同中规定的严格保密义务，否则可将被处分或被解约。
      </div>
      <p>四. 找我请柬如何处理未成年人提供的个人信息</p>
      <div class="textInfo">
        1.
        <b
          >找我请柬非常重视未成年人信息的保护。找我请柬只会在法律允许的范围内，或依当地法律取得监护人的同意，或是为了保护未成年人而使用或披露有关未成年人的个人数据。“未成年人”的定义应考虑适用的法律以及各国家和地区的文化惯例。</b
        >
      </div>
      <p>五. 您分享的信息</p>
      <div class="textInfo">
        1.
        找我请柬会提供社交网络服务，您在使用这一类型服务时，您所上传或发布的信息（包括您公开的个人信息、您的通讯录、好友圈）、您对他人上传或发布的信息作出的回应，以及与这些信息有关的日志信息等，只要您不删除这些信息，它们会一直留存在公共领域，并被使用找我请柬服务的其他用户分享、浏览。即使您删除这些信息，有关信息仍可能由其他用户或不受找我请柬控制的非关联第三方独立地缓存、复制或储存，或由其他用户或第三方在公共领域保存。
      </div>
      <div class="textInfo">
        2.
        请您谨慎考虑通过找我请柬的服务上传、发布和交流的信息内容。在一些情况下，您可通过找我请柬某些服务的隐私设定来控制有权浏览您共享信息的用户范围。您可以自行删除您上传、发布或分享的信息，如要求找我请柬为您删除您的相关信息，请发送邮件到service@izhaowo.com与找我请柬联络并提出您的要求。
      </div>
      <div class="textInfo">
        3.
        <b
          >如您考虑弃用找我请柬App并想清除您的个人信息，可以在<span
            style="font-weight: 600"
            >【我的-设置-注销】</span
          >中得到相关指引，我们将会在看到您的诉求后的15个工作日内删除您的个人信息及副本。</b
        >
      </div>
      <p>六. 数据传输</p>
      <div class="textInfo">
        1.
        找我请柬维护着遍布世界各地的服务器，因此，找我请柬处理您的信息时所用的服务器可能并不是位于您所在的国家或地区。数据保护法律因国家或地区而异，不同国家或地区的数据保护力度也是有强有弱。无论是在哪里处理您的信息，找我请柬都会一律采用本政策中所述的保护措施。另外，找我请柬还会遵守某些与数据传输有关的法律框架，例如“EU-US
        Privacy Shield Frameworks”和“Swiss-US Privacy Shield Frameworks”。
      </div>
      <div class="textInfo">
        2.
        收到正式的书面投诉后，找我请柬会与投诉方联系。找我请柬会与相应的监管机构（包括当地的数据保护机构）合作，以解决任何与传输您的数据有关且无法由找我请柬和您直接解决的投诉。
      </div>
      <p>七. 第三方服务提供商</p>
      <div class="textInfo">
        1.
        为方便您的访问并丰富您的体验，可能会有第三方提供的产品或服务。您可以选择是否访问这类内容或链接，或是否使用该第三方的产品或服务。但找我请柬对于第三方提供的产品或服务没有控制权。找我请柬无法控制第三方掌握的您的任何个人信息。您在使用第三方产品或服务过程中的信息保护问题，不适用于本政策的管理。本政策也不适用于您自行选择提供给第三方的任何信息。请您查看该第三方的隐私保护政策。
      </div>
      <p>八.本政策的更新</p>
      <div class="textInfo">
        1.
        找我请柬可能会不定期修改、更新本隐私政策，有关隐私政策的更新，找我请柬会在找我请柬APP中以通知公告等形式发布，您可以访问找我请柬查询最新版本的隐私政策。<b
          >对于重大变更，找我请柬会向您发出郑重通知（包括对于某些服务，找我请柬会通过电子邮件发送通知，说明对隐私政策进行的更改）。</b
        >
      </div>
      <p>九. 适用范围</p>
      <div class="textInfo">
        1.
        找我请柬的隐私政策适用于由成都爱找我科技有限公司及其关联公司提供的所有服务，包括找我请柬及www.izhaowo.com上提供的服务，但是不包括附有独立隐私政策的服务（如第三方提供的产品和服务）。
      </div>
      <div class="textInfo">
        2.
        找我请柬的隐私权政策不适用于第三方提供的产品和服务，例如在找我请柬及www.izhaowo.com上由第三方提供的产品和服务，以及在找我请柬的服务中链接到的其他网站，这些产品、服务或网站会有独立的隐私政策予以规范，请另行查阅相应的政策规定。
      </div>
      <div class="textInfo">
        3.
        对于为找我请柬的服务进行广告宣传，以及可能使用找我请柬的cookie或其他日志信息来投放和使用广告的其他公司和组织，找我请柬的隐私权政策并未涵盖其信息处理政策。
      </div>
    </div>
    <div class="info">
      <p class="align" style="margin-bottom: 0.2rem">《找我请柬服务协议》</p>
      <div class="textInfo">
        欢迎使用“找我请柬”平台提供的服务，本协议是您（也称“用户”）与“找我请柬”平台所有者：成都爱找我科技有限公司（也称“找我请柬”）之间就“找我请柬”平台服务等相关事宜所订立的契约。为了保障您的权益，请在使用“找我请柬”平台前，详细阅读本协议的所有内容，特别是加粗部分。当您勾选“我已看过并同意《用户协议》”时，您的行为表示您同意并签署了本协议，并同意遵守本协议中的约定。该协议构成您与“找我请柬”达成的协议，具有法律效力。否则，您请勿注册或使用找我请柬”平台服务。您的注册、登陆、使用等行为将视为对本协议的接受，本协议即构成对双方有约束力的法律文件。
      </div>
      <div class="textInfo">
        本协议内容包括协议正文、本协议下述条款明确援引的其他协议、找我请柬已经发布的或将来可能发布的各类规则。所有规则为本协议不可分割的组成部分，与协议正文具有同等法律效力。一旦相关内容发生变动，找我请柬将会通过电子邮件或找我请柬平台公告等方式提示您。如果您不同意对本协议内容所做的修改，则应立即停止使用本服务；如果您继续使用本服务的，则视为您同意对本协议内容所做的修改。
      </div>
      <p>一、账户注册和使用</p>
      <div class="textInfo">
        1、为了能使用找我请柬平台提供的服务，您同意以下事项：依本服务注册提示请您填写正确的注册账号、密码和名号，并确保今后更新的登录信息、名号、头像等资料的有效性和合法性。若您提供任何违法、不道德或认为不适合在找我请柬平台上展示的资料；或者找我请柬有理由怀疑你的资料属于程序或恶意操作，找我请柬有权暂停或终止您的帐号，并拒绝您于现在和未来使用本服务的全部或任何部分。
      </div>
      <div class="textInfo">
        2、找我请柬没有法律责任应当对用户的任何登记资料进行审查，用户资料的真实性、完整性、合法性等，应当由用户自己保证，找我请柬不承担因用户资料的虚假等引起的任何法律责任。
      </div>
      <p>二、用户帐号、密码及安全</p>
      <div class="textInfo">
        1、完成本服务的注册程序并成功注册之后，您可使用您的账号和密码，登录到您在找我请柬的帐号（下称“帐号”）。保护您的帐号安全，是您的责任。您应对所有使用您的密码及帐号的活动负完全的责任。您同意：
      </div>
      <div class="textInfo">
        1）您的找我请柬帐号遭到未获授权的使用，或者发生其它任何安全问题时，您将立即通知找我请柬；
      </div>
      <div class="textInfo">
        2）如果您未保管好自己的帐号和密码，因此而产生的任何损失或损害，找我请柬无法也不承担任何责任；
      </div>
      <div class="textInfo">
        3）您需保管好注册找我请柬用户账号的手机号码或第三方授权登录账户，保证注册手机号码或第三方授权登录账户可正常使用，避免有销户、丢失或第三方授权登录密码忘记等其它无法使用的情况，如因您个人原因无法正常使用账号而造成损失或损害，您将负全部责任
        。
      </div>
      <div class="textInfo">
        4）每个用户都要对其帐号中的所有行为和事件负全责。如果您未保管好自己的帐号和密码而对您、找我请柬或第三方造成的损害，您将负全部责任。
      </div>
      <div class="textInfo">
        5）如果用户注册找我请柬帐号后连续180天不登录，为避免造成资源浪费，找我请柬在通知用户后，有权收回该帐号，由此造成的不利后果由用户自行承担。找我请柬在对此类账户进行清理前，将以包括但不限于网站公告、站内消息等方式通知用户。
      </div>
      <p>三、找我请柬服务</p>
      <div class="textInfo">
        1、找我请柬您提供平台化服务。您可以浏览由商家发布的商品和服务信息。您登录找我请柬后，可选购各商家的商品或服务，与之达成交易意向并进而完成交易，您还可以参加找我请柬组织的活动，使用其它信息服务及技术服务。
      </div>
      <div class="textInfo">
        2、商家是指通过找我请柬陈列、售卖商品或服务，并最终和您完成交易的主体，是商品或服务的供应商和服务提供人员。
      </div>
      <div class="textInfo">3、找我请柬目前向用户提供如下服务：</div>
      <div class="textInfo">
        1）用户可以在找我请柬浏览、分享、收藏婚礼案例作品，挑选合适的婚礼服务，下单预订提供婚礼服务的策划师、主持人、摄影师、摄像师、化妆师等职业人；采购婚品；分享案例；使用找我请柬工具集合提供的各种工具如请帖等。除非本协议另有其它明示规定，增加或强化目前本服务的任何新功能，包括所推出的新产品，均受到本协议之规范。
      </div>
      <div class="textInfo">
        2）您了解并同意，本服务仅依其当前所呈现的状况提供，对于任何用户信息或个人化设定之时效、删除、传递错误、未予储存或其它任何问题，找我请柬均不承担任何责任。找我请柬保留不经事先通知为维修保养、升级或其它目的暂停本服务任何部分的权利。
      </div>
      <p>四、找我请柬的权利</p>
      <div class="textInfo">
        1、本服务及本服务所使用相关软件（以下简称“软件”）含有受到相关知识产权及其它法律保护之专有保密资料；
      </div>
      <div class="textInfo">
        2、经由本服务或广告商向您呈现之赞助广告或信息所包含之内容，亦受到著作权、商标权、专利权或其它专属权利之法律保护。未经找我请柬等权利人明示授权，您不得修改、出租、出借、出售、散布本服务或软件之任何部份或全部，或据以制作衍生著作，或使用擅自修改后的软件，包括但不限于为了未经授权而使用本服务之目的；
      </div>
      <div class="textInfo">
        3、仅授予您个人、不可移转及非专属之使用权，使您得于单机计算机使用其软件之目的码，但您不得（并不得允许任何第三人）复制、修改、创作衍生著作、进行还原工程、反向组译，或以其它方式发现原始码，或出售、转让、再授权或提供软件设定担保，或以其它方式移转软件之任何权利。
      </div>
      <div class="textInfo">
        4、将通过由找我请柬所提供的界面而非任何其它途径使用本服务。
      </div>
      <p>五、找我请柬服务规范</p>
      <div class="textInfo">
        1、找我请柬并非商品和服务的提供方或售卖方，该等商品和服务由商家向您提供，由其承担其商品和服务的质量保证责任。找我请柬会促使商家尽可能准确、详尽地描述其提供商品和服务内容。然而找我请柬不能保证找我请柬上所有商品或服务的相关内容是准确、完整、可靠、有效和没有错误的。需要特别说明的是，由于用不同的网络浏览器或不同的计算机显示屏观看时网页显示的差异，找我请柬上促销的商品在图像和颜色方面可能跟真实的物品不尽一致；找我请柬展示的婚礼视频图片和现场不尽一致。因此，所有显示的图片、视频和其他商品显示方法仅限于图示目的。
      </div>
      <div class="textInfo">
        2、您在找我请柬所选购商品和服务的描述均由商家提供，仅由他们对其真实性负责。您应该对您对该等商品和服务所作出的判断负责，找我请柬不参与您与商家的交易。对于任何种类的直接或间接的由于商品或服务的质量造成的损失，找我请柬不负责，但将根据找我请柬的相关规则督促商家履行对您的售后保障服务。
      </div>
      <div class="textInfo">
        3、除非另有证明，找我请柬储存在其服务器上的数据是您使用找我请柬服务的唯一有效证据。
      </div>
      <div class="textInfo">
        4、除法律另有规定外，找我请柬保留自行决定是否提供服务、注销用户帐号、清除或编辑内容或取消订单的权利。
      </div>
      <p>六、找我请柬使用规则</p>
      <div class="textInfo">
        1、您可浏览找我请柬中商家陈列的商品或服务信息，如您希望选购并支付订单的，您需先登录或注册邮箱帐号，并根据页面提示提交选购的商品信息和个人信息，包括但不限于数量、规格、手机、姓名、身份证照片、送货地址等信息。
      </div>
      <div class="textInfo">
        您在注册时承诺遵守法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性等七条底线，不得在注册资料中出现违法和不良信息，且您保证其在注册和使用帐号时，不得有以下情形：
      </div>
      <div class="textInfo">（a）违反宪法或法律法规规定的；</div>
      <div class="textInfo">
        （b）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
      </div>
      <div class="textInfo">（c）损害国家荣誉和利益的，损害公共利益的；</div>
      <div class="textInfo">（d）煽动民族仇恨、民族歧视，破坏民族团结的；</div>
      <div class="textInfo">（e）破坏国家宗教政策，宣扬邪教和封建迷信的；</div>
      <div class="textInfo">（f）散布谣言，扰乱社会秩序，破坏社会稳定的；</div>
      <div class="textInfo">
        （g）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；
      </div>
      <div class="textInfo">（h）侮辱或者诽谤他人，侵害他人合法权益的；</div>
      <div class="textInfo">（i）含有法律、行政法规禁止的其他内容的。</div>
      <div class="textInfo">
        若您提供给找我请柬公司的帐号注册资料不准确，不真实，含有违法或不良信息的，找我请柬公司有权不予注册，并保留终止您使用找我请柬各项服务的权利。若您以虚假信息骗取帐号注册或帐号头像、个人简介等注册资料存在违法和不良信息的，找我请柬公司有权采取通知限期改正、暂停使用、注销登记等措施。对于冒用关联机构或社会名人注册帐号名称的，找我请柬公司有权注销该帐号，并向政府主管部门进行报告。
      </div>
      <div class="textInfo">
        根据相关法律、法规规定以及考虑到找我请柬产品服务的重要性，您同意：
      </div>
      <div class="textInfo">
        （a）在注册帐号时提交个人有效身份信息进行实名认证；
      </div>
      <div class="textInfo">（b）提供及时、详尽及准确的帐户注册资料；</div>
      <div class="textInfo">
        （c）不断更新注册资料，符合及时、详尽准确的要求，对注册邮箱帐号时填写的身份证件信息不能更新。
      </div>
      <div class="textInfo">
        1、您确认：在使用找我请柬服务过程中，您应当是具备完全民事权利能力和完全民事行为能力的自然人、法人或其他组织。若您不具备前述主体资格，则您及您的监护人应承担因此而导致的一切后果，找我请柬有权向您的监护人追偿。
      </div>
      <div class="textInfo">
        2、您同意并保证：找我请柬有权记录您在选购商品或服务时，在线填写的所有信息并提供给商家、第三方服务提供者（包括但不限于物流公司）或找我请柬的关联公司。您保证该等信息准确、合法，您承担因该等信息错误、非法等导致的后果。您授权找我请柬在本服务期间有权使用上述信息及将向有关第三方提供该信息。如您提供的信息过期、无效进而导致商家或找我请柬无法与您取得联系的，因此导致您在使用找我请柬服务中产生任何损失或增加费用的，应由您完全独自承担。
      </div>
      <div class="textInfo">
        3、您理解并同意：您在找我请柬下单订购商品或服务时需按照找我请柬提示支付相应的款项，您及时、足额、合法的支付选购商品或服务所需的款项是商家或职业人提供商品或服务的前提。
      </div>
      <div class="textInfo">
        4、您支付交易款项过程中，将被邀请复查选购商品或服务的信息，包括订购商品信息、预订服务提供时间，费用等。前述存储于找我请柬服务器的订单信息被认为是您的该次交易对应的订购商品信息、服务提供时间和争议事项的证据。您点击确认或支付相应费用后意味着您认可订单的所有信息都是正确和完整的。由于众所周知的互联网技术因素等客观原因存在，找我请柬显示的信息可能会有一定的滞后性或差错，对此情形您知悉并理解。在由于排版错误或信息错误的情况下以不正确的价格列出来的商品，找我请柬有拒绝或取消任何对以不正确的价格列出来的商品或服务所下订单的权利。
      </div>
      <div class="textInfo">5、您理解并同意找我请柬上的订单成立规则：</div>
      <div class="textInfo">
        （a）找我请柬上展示的商品或服务以及其价格、规格等信息，其性质仅为要约邀请，是商家希望您向其发出要约的意思表示；
      </div>
      <div class="textInfo">
        （b）当您确定购买并成功提交订单时（您的订单内容应包含您预订服务提供时间、服务人员、购买的商品数量、价格及支付方式、收货人、联系方式、收货地址等信息），视为您向商家发出了购买订单商品的要约；
      </div>
      <div class="textInfo">
        （c）订单提交成功的信息是系统自动生成，并非商家对您要约的承诺。只有系统将订单信息反馈至商家，经商家确认能够满足您订购需求时，方视为商家对您的要约作出承诺，此时您与商家之间就该次交易成立了合同关系。
      </div>
      <div class="textInfo">
        若您预订完成相应服务订单后，在商家提供服务前退订的，则您知晓并同意找我请柬有权按照找我请柬公示相关退单规则扣除您已支付相应费用或要求您另行支付相应费用作为支付给相应商家的违约金。
      </div>
      <div class="textInfo">
        6、您可将您与商家关于交易的争议提交找我请柬，您同意委托找我请柬单方判断与该争议相关的事实及应适用的规则，进而作出处理决定，该判断和决定将对您具有法律约束力。但您理解并同意，找我请柬并非司法机构，仅能以普通人的身份对证据进行鉴别，找我请柬对争议的调处完全是基于您的委托，找我请柬无法保证争议处理结果符合您的期望，也不对争议调处结论承担任何责任。如您因此遭受损失，您同意自行向责任方追偿。
      </div>
      <div class="textInfo">
        7、为使您能够及时、全面了解找我请柬提供的各类商品、服务及活动，您了解并同意，找我请柬可以通过您在注册、使用找我请柬过程中提供的联系方式多次、长期向您发送各类商业性短信息而无需另行获得您的同意。
      </div>
      <div class="textInfo">
        8、您了解并同意，根据国家相关的外汇监管法律法规，您委托找我请柬接入的第三方支付机构向其合作银行发送购买外汇的请求并将相关支付信息及支付账户实名认证信息（包括姓名及身份证号码等）发送给找我请柬。因此您还需同意该第三方支付机构需要您确认的相关协议，并承担由此所产生的法律后果。您同时确认，如您在找我请柬的实名认证信息与第三方支付机构发送给找我请柬的支付账户实名认证信息不一致时，您不可撤销地授权找我请柬根据法律法规、跨境电子商务政策及第三方支付机构的信息来匹配订购人信息以发送给海关用于清关，您确认您已获得支付账户实名认证人的有效授权使用其实名认证信息并自行承担因此产生的所有责任。
      </div>
      <div class="textInfo">
        11、您知悉并同意，找我请柬将按照找我请柬《隐私政策》的约定收集、使用并保护您的相关信息。
      </div>
      <p>七、其他约定</p>
      <div class="textInfo">
        1、您如对本协议项下找我请柬服务有任何疑问，请登录获取相关信息或拨打客服电话（4000-119-139），找我请柬将为您提供【7*16】小时服务。
      </div>
      <div class="textInfo">2、责任范围和限制</div>
      <div class="textInfo">
        A
        您了解找我请柬仅提供这一平台作为您获取商品或服务信息、物色交易对象、就商品和/或服务的交易进行协商及开展交易的非物理场所，但找我请柬无法控制交易所涉及的物品的质量、安全或合法性，商贸信息的真实性或准确性，以及交易各方履行其在贸易协议中各项义务的能力。您应自行谨慎判断确定相关商品及/或信息的真实性、合法性和有效性，并自行承担因此产生的责任与损失。
      </div>
      <div class="textInfo">
        B 对发生下列情形之一所造成的不便或损害，找我请柬免责：
      </div>
      <div class="textInfo">
        a
        定期检查或施工，更新软硬件而造成的服务中断，或突发性的软硬件设备与电子通信设备故障；
      </div>
      <div class="textInfo">
        b
        网络服务提供商线路或其他故障，黑客攻击、病毒入侵等，服务器遭受损害，无法正常运作；
      </div>
      <div class="textInfo">c 在紧急情况之下依照法律的规定而采取的措施；</div>
      <div class="textInfo">d 您与其它任何第三方的纠纷</div>
      <div class="textInfo">
        e无论何种原因找我请柬对您的购买行为的赔偿金额将不会超过您受到影响的当次购买行为已经实际支付的费用的总额。
      </div>
      <div class="textInfo">3、所有权及知识产权：</div>
      <div class="textInfo">
        1）找我请柬上所有内容，包括但不限于文字、软件、声音、图片、录像、图表、网站架构、网站画面的安排、网页设计、在广告中的全部内容、商品以及其它信息均由找我请柬或其他权利人依法拥有其知识产权，包括但不限于商标权、专利权、著作权、商业秘密等。非经找我请柬或其他权利人书面同意，您不得擅自使用、修改、全部或部分复制、公开传播、改变、散布、发行或公开发表、转载、引用、链接、抓取或以其他方式使用本平台程序或内容。如有违反，您同意承担由此给网易考拉或其他权利人造成的一切损失。
      </div>
      <div class="textInfo">
        2）找我请柬不保证平台上由其他权利人提供的所有内容没有侵犯任何第三方的合法权益，如您认为前述内容侵犯您的合法权益，请及时与找我请柬客服联系，找我请柬将在法律规定范围内协助您解决问题。
      </div>
      <div class="textInfo">
        3）任何您接受本协议,即表明用户已将其在找我请柬发表的摄影、文字等作品著作权利无偿许可找我请柬行使并授权予以修改，但上述用户著作权利不含《中华人民共和国著作权法》第十条第一款第（一）项、第（二）项和第（四）项等不得许可的权利。
      </div>
      <div class="textInfo">
        4）找我请柬服务与资料是基于“现状”提供，而且找我请柬明确地表示拒绝对于“服务”“资料”或“产品”给予任何明示或暗示之保证，包括但不限于，得为商业使用或适合于特定目的之保证。找我请柬对于因“服务”“资料”或“产品”所生之任何直接、间接、附带的或因此而导致之衍生性损失概不负责。如果您对他人的知识产权造成了侵害，找我请柬将依国家法律法规的规定，或在适当的情形下，将依其服务条款或其相关规范性规定，删除特定内容或以至终止您对账户的使用。
      </div>
      <div class="textInfo">
        5）若您认为您的作品的著作权遭到侵害或您的知识产权被侵犯，根据《信息网络传播权保护条例》的规定，您需及时向找我请柬联系并提供详实的举证材料。或请到中华人民共和国国家版权局下载《要求删除或断开链接侵权网络内容的通知》（下称“删除通知”）的示范格式，如果您不明白“删除通知”的内容，请登录中华人民共和国国家版权局查看《要求删除或断开链接侵权网络内容的通知》填写说明。
      </div>
      <p>八、公开信息</p>
      <div class="textInfo">
        1、在本协议中，“本服务公开使用区域”系指一般公众可以使用的区域。
      </div>
      <div class="textInfo">
        2、用户在找我请柬上传或发布的内容，用户应保证其为著作权人或已取得合法授权，并且该内容不会侵犯任何第三方的合法权益，用户同意授予找我请柬所有上述内容在全球范围内的免费、不可撤销的、永久的、可再许可或转让的独家使用权许可，据该许可找我请柬将有权以展示、推广及其他不为我法律所禁止的方式使用前述内容。
      </div>
      <p>九、用户的违约及处理</p>
      <div class="textInfo">1、发生如下情形之一的，视为您违约：</div>
      <div class="textInfo">
        1）使用找我请柬平台服务时违反有关法律法规规定的；
      </div>
      <div class="textInfo">2）违反本协议约定的。</div>
      <div class="textInfo">
        为满足海量用户对高效优质服务的需求，您理解并同意，找我请柬可在找我请柬平台规则中约定违约认定的程序和标准。
      </div>
      <div class="textInfo">
        2、您应当遵守法律、法规、规章以及政府任何具有法律效力之规范，并对以任何方式使用您的密码和您的帐号使用本服务的任何行为及其结果承担全部责任。如您的行为因违法，有可能构成犯罪的，将被追究刑事责任，并由您承担全部法律责任。
      </div>
      <div class="textInfo">
        同时如果找我请柬有理由认为您的任何行为，包括但不限于您的任何言论和其它行为违反法律、法规、规章以及政府任何具有法律效力之规范规定，找我请柬可在任何时候不经任何事先通知终止向您提供服务。您违反本服务协议的，找我请柬也有权终止对您的服务。终止服务将关闭或删除您的帐号及您帐号中所有相关信息及文件，及/或禁止继续使用前述文件或本服务。
      </div>
      <div class="textInfo">
        3、由于您通过本服务提供、发布或传送之内容、您与本服务连线、您违反本协议、或您侵害他人任何权利因而衍生或导致任何第三人提出任何索赔或请求，包括合理的律师费，您同意赔偿找我请柬及其子公司、关联企业、高级职员、代理人、品牌共有人或其它合作伙伴及员工，并使其免受损害，并承担由此引发的全部法律责任。
      </div>
      <p>十、数据储存</p>
      <div class="textInfo">
        1、您同意不对本服务任何部分或本服务之使用或获得，进行复制、拷贝、出售、转售或用于任何其它商业目的。
      </div>
      <div class="textInfo">
        2、您承认关于本服务的使用找我请柬有权制订一般措施及限制，包含但不限于本服务将保留所发布内容或其它发布内容之最长期间，以及一定期间内您使用本服务之次数上限（及每次使用时间之上限）。通过本服务发布或传送之任何信息、通讯资料和其它内容，如被删除或未予储存，您同意找我请柬毋须承担任何责任。您也同意，找我请柬有权依其自行之考虑，不论通知与否随时变更这些一般措施及限制。
      </div>
      <p>十一、不可抗力及其他免责事由</p>
      <div class="textInfo">
        1、本协议的任何规定不会免除找我请柬对造成您人身伤害的、或因故意或重大过失造成您财产损失的任何责任，但无法对由于战争、地震、水灾、火灾、暴风雪或其他不可抗力等第三方原因给您造成的损失承担责任；
      </div>
      <div class="textInfo">
        2、您使用本服务之风险由您个人负担。本服务系依“现状”及“现有”基础提供。找我请柬对本服务不提供任何明示或默示的担保或保证，包含但不限于商业适售性、特定目的之适用性及未侵害他人权利等担保或保证；
      </div>
      <div class="textInfo">3、找我请柬不保证以下事项∶</div>
      <div class="textInfo">• 本服务将符合您的要求；</div>
      <div class="textInfo">
        • 本服务将不受干扰、及时提供、安全可靠或不会出错；
      </div>
      <div class="textInfo">• 使用本服务取得之结果正确可靠；</div>
      <div class="textInfo">
        • 您经由本服务购买或取得之任何产品、服务、资讯或其它信息将符合您的期望；
      </div>
      <div class="textInfo">
        4、是否使用本服务下载或取得任何资料应由您自行考虑且自负风险，因任何资料之下载而导致的您电脑系统之任何损坏或数据流失等后果，由您自行承担；
      </div>
      <div class="textInfo">
        5、您自找我请柬或经由本服务取得的任何建议或信息，无论是书面或口头形式，除非本协议有明确规定，将不构成本协议以外的任何保证。
      </div>
      <p>十二、法律适用、管辖及其他</p>
      <div class="textInfo">
        1、本协议和《隐私政策》及找我请柬平台公示规则均为构成您与找我请柬之全部协议组成部分，具有同等法律效力。在您使用相关服务、使用第三方提供的内容或软件时，亦应遵从所适用之附加条款及条件；
      </div>
      <div class="textInfo">
        2、本协议及您与找我请柬之关系，均受到中华人民共和国法律管辖。您与找我请柬就本服务、本协议或其它有关事项发生的争议，应首先友好协商解决，协商不成时应向找我请柬注册所在地法院提起诉讼；
      </div>
      <div class="textInfo">
        3、找我请柬未行使或执行本协议任何权利或规定不构成对前述权利或权利之放弃；
      </div>
      <div class="textInfo">
        4、倘本协议之任何规定因与中华人民共和国法律抵触而无效，您依然同意应依照法律，努力使该规定所反映之当事人意向具备效力，且本协议其它规定仍应具有完整的效力及效果。
      </div>
    </div>
  </div>
</template>

<!--样式-->
<style>
@import "../../assets/css/base.css";

.info {
  padding: 0.2rem 0.4rem;
  font-family: PingFangSC-Regular;
  font-size: 0.26rem;
  color: #333333;
  text-align: justify;
  line-height: 0.4rem;
  background: #fff;
}
.info > div {
  margin-bottom: 0.2rem;
}
.info > p {
  color: #151515;
  font-weight: bold;
  margin-bottom: 0.2rem;
}
.info > p.align {
  text-align: center;
  margin: 0 auto;
}
</style>

<script>
export default {
  name: "menuAddress",
  created() {
    document.title = "隐私政策&服务协议";
  },
};
</script>
<style scoped>
td {
  border: 1px solid #ececec;
  text-align: center;
  padding: 0.16rem 0.1rem;
}
a {
  word-break: break-all;
  cursor: pointer;
}
b {
  font-weight: bold;
  color: #151515;
}
</style>



// WEBPACK FOOTER //
// ecardProtocol.vue?7a3b6ad0